import { NotificationPageComponent } from './notification-page/notification-page.component';
import { ClientSendEmailDialogComponent } from './client-nfs-page/client-send-email-dialog/client-send-email-dialog.component';
import { ClientNfsPageComponent } from './client-nfs-page/client-nfs-page.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { MiscModule } from 'projects/core/src/public-api';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AccordionModule } from 'primeng/accordion';
import { ListboxModule } from 'primeng/listbox';
import { PaginatorModule } from 'primeng/paginator';
import { NotificationModule } from 'projects/app-misc/src/app/modules/notification/notification.module';
import { ClientMessageComponent } from './client-nfs-page/client-message/client-message.component';
import { TooltipModule } from 'primeng/tooltip';
import { NfsEmailsDialogComponent } from './client-nfs-page/client-send-email-dialog/nfs-emails-dialog/nfs-emails-dialog.component';
import { InputTextModule } from 'primeng/inputtext';
import { MatInputModule } from '@angular/material/input';
import { MentionPageComponent } from './mention-page/mention-page.component';
import {RouterModule} from '@angular/router';

@NgModule({
	declarations: [
		NotificationPageComponent,
		ClientNfsPageComponent,
		ClientSendEmailDialogComponent,
		ClientMessageComponent,
		NfsEmailsDialogComponent,
  MentionPageComponent

	],
	imports: [
		CommonModule,
		BrowserModule,
    RouterModule,
		NotificationModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		ButtonModule,
		MatButtonModule,
		MatRippleModule,
		MatIconModule,
		MatFormFieldModule,
		OverlayPanelModule,
		CheckboxModule,
		MultiSelectModule,
		SelectButtonModule,
		CalendarModule,
		CheckboxModule,
		MiscModule,
		MatInputModule,
		DropdownModule,
		ConfirmDialogModule,
		AccordionModule,
		MultiSelectModule,
		ListboxModule,
		TooltipModule,
		InputTextModule,
		PaginatorModule
	],
	exports: [
		NotificationPageComponent,
		ClientNfsPageComponent,
		ClientSendEmailDialogComponent,
		ClientMessageComponent
	],
	entryComponents: [
		ClientSendEmailDialogComponent,
		NfsEmailsDialogComponent]
})
export class ClientNfsModule { }
